import React from "react";
import styles from "./orderTogether.module.scss";
import { connect } from "react-redux";

const OrderTogether = ({ data, customer = {} }) => {
  const handleStatus = (status = "") => {
    switch (status) {
      case -1:
        return "Cancelled";
      case 0:
        return "Placed";
      case 1:
        return "Packed";
      case 2:
        return "Shiped";
      case 3:
        return "Delivered";
    }
  };
  console.log("ordered together", data?.length, data);
  return (
    <div className={styles.container}>
      {data.map((item) => (
        <div key={item.orderId} className={styles.orderCard}>
          <div className={styles.infoRow}>
            <div className={styles.label}>Order ID</div>
            <div className={styles.value}> :{item?.orderCode}</div>
          </div>
          <div className={styles.infoRow}>
            <div className={styles.label}>Customer Name</div>
            <div className={styles.value}>: {customer?.fullName}</div>
          </div>
          <div className={styles.infoRow}>
            <div className={styles.label}>Ordered Quantity</div>
            <div className={styles.value}>: {item?.quantity}</div>
          </div>
          <div className={styles.infoRow}>
            <div className={styles.label}>Status</div>
            <div className={styles.value}>: {handleStatus(item.status)}</div>
          </div>
        </div>
      ))}
    </div>
    // <div className={styles.container}>
    //   {data?.length > 1 &&
    //     data.map((item) => (
    //       <div key={item.orderId} className={styles.orderCard}>
    //         <div className={styles.infoRow}>
    //           <div className={styles.label}>Order ID</div>
    //           <div className={styles.value}>: {item.id}</div>
    //         </div>
    //         <div className={styles.infoRow}>
    //           <div className={styles.label}>Customer ID</div>
    //           <div className={styles.value}>: {customer?.fullName}</div>
    //         </div>
    //         <div className={styles.infoRow}>
    //           <div className={styles.label}>Cart Bundle ID</div>
    //           <div className={styles.value}>: {item.cartBundleId}</div>
    //         </div>
    //         <div className={styles.infoRow}>
    //           <div className={styles.label}>Status</div>
    //           <div className={styles.value}>: {handleStatus(item.status)}</div>
    //         </div>
    //       </div>
    //     ))}
    // </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    customer: state?.customer?.customer,
  };
};

export default connect(mapStateToProps, null)(OrderTogether);
